export default {
  EXCEL: 'xlsx',
  CSV: 'csv',
  NONE: 'none',
};
